module.exports = __webpack_public_path__ + "img/C345EC_5F1DAA_9F31DB_872CCD-256px.29aee8aa.png";